import { Rop03FormStyle as S } from 'src/pages/Rop03JoinFormPage/styled'
import { Banner } from 'src/components/Banner'
import React, { useEffect, useState } from 'react'
import InputElement from 'src/pages/Rop03JoinFormPage/components/InputElement'
import AgencyTabList from 'src/components/AgencyTabList'
import { Rop03JoinFormPageProps } from 'src/pages/Rop03JoinFormPage/index'
import { useFormContext } from 'react-hook-form'
import { JoinFormType } from 'src/types/react-hook-form'
import { VerticalDivider } from 'src/components/Divider'
import RenderIf from 'src/components/RenderIf'
import { Button } from './components/Button'
import { LayoutGroup, motion, MotionConfig, Transition } from 'framer-motion'
import Terms from 'src/pages/Rop03JoinFormPage/components/Terms'
import ArrowRight from 'src/assets/images/rop03/arrow_rt.svg'
import ArrowLottie from 'src/assets/images/rop03/arrow.json'
import Lottie from 'lottie-react'
import Toast from 'src/pages/Rop03JoinFormPage/components/ToastPopup'
import handleAutoInputGuard from 'src/service/utils/handleAutoInputGuard'
import { decodeBase64Html } from 'src/service/utils/decode'

const Rop03JoinFormPageView = (props: Rop03JoinFormPageProps) => {
  const {
    dynamicUiData: { FooterContent, NotiContent, ButtonMsgAfter, TopImage, MiddleImage, UIData },
    registerAttribute,
    otpCertRequest,
    otpCertVerify,
    count,
    originCount,
    isOtpRequestPending,
    isOtpVerifyPending,
    isMvnoVerifyPending,
    isVulnerableVerifyPending,
    isPNumFilled,
    isCertStep,
    isCertFilled,
    isOtpReady,
    userPNumber,
    didFlip,
    isToastShow,
    toastMsg,
    bannerScrollRef,
    agencyScrollRef,
    pNumberScrollRef,
    pNumberInputRef,
    approvalNumberInputRef,
    scrollToBanner,
    scrollToAgency,
    scrollToPNumber,
  } = props
  const { handleSubmit, setValue, setFocus, register } = useFormContext<JoinFormType>()
  const isJoinSubmitting = isVulnerableVerifyPending || isOtpVerifyPending
  const { layoutsFooter, layoutsInsert, layoutsVerify, layoutsConfirm } = UIData
  const handleSubmitOtpCertRequest = handleSubmit(otpCertRequest.submit, otpCertRequest.error)
  const handleSubmitOtpVerify = handleSubmit(otpCertVerify.submit, otpCertVerify.error)

  const [isPNumberFocus, setIsPNumberFocus] = useState<boolean>(false)
  const [isApprovalNumberFocus, setIsApprovalNumberFocus] = useState<boolean>(false)
  const [isLockScoll, setIsLockScroll] = useState(true)

  const SPRING: Transition = { type: 'spring', stiffness: 380, damping: 30, mass: 1.2 } as const

  useEffect(() => {
    isCertFilled && scrollToPNumber()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCertFilled])

  useEffect(() => {
    setTimeout(() => setIsLockScroll(false), 200)
  }, [])

  return (
    <S.Rop03FormBackground>
      <S.Rop03FormContainer>
        {/* 배너 START */}
        <Banner.Container>
          <Banner.Items img={TopImage} id="top_Image" />
          <div ref={bannerScrollRef} />
          <Banner.Items img={MiddleImage} id="middle_Image" />
        </Banner.Container>
        {/* 배너 END */}
        {/* 가입폼 START */}
        <S.CertFormContainer $mainBg={layoutsInsert?.mainBg}>
          {/*통신사선택*/}
          <InputElement
            label={
              <div ref={agencyScrollRef}>
                <strong>통신사</strong>를 선택해주세요
              </div>
            }
            children={<AgencyTabList {...props} layoutsInsert={layoutsInsert} />}
            onClick={() => {
              pNumberInputRef.current?.focus()
            }}
            disabled={isCertStep}
          />
          <div>
            {/*휴대폰번호 Input*/}
            <InputElement
              type={'input'}
              isValid={isPNumFilled}
              disabled={isCertStep}
              $inputStyle={S.PNumberInputStyle({
                isFocus: isPNumberFocus,
                isValid: isPNumFilled,
                ...layoutsInsert?.certs,
              })}
              label={
                <div ref={pNumberScrollRef}>
                  <strong>휴대폰번호</strong>를 입력해주세요
                </div>
              }
              children={
                <>
                  <span>010</span>
                  <VerticalDivider height={'16px'} color={'#ccd0d8'} />
                  <input
                    {...register('PNumber', registerAttribute.PNumber.register_options)}
                    ref={pNumberInputRef}
                    type={'tel'}
                    placeholder={'1234 5678'}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault()
                        handleSubmitOtpCertRequest()
                      }
                    }}
                    autoComplete={'off'}
                    disabled={isCertStep}
                    value={
                      userPNumber.length > 4 && userPNumber[4] !== ' '
                        ? `${userPNumber.slice(0, 4)} ${userPNumber.slice(4)}`
                        : userPNumber
                    }
                    onFocus={() => {
                      setIsPNumberFocus(true)
                      !isLockScoll && scrollToBanner()
                    }}
                    onBlur={() => setIsPNumberFocus(false)}
                    onClick={scrollToBanner}
                  />
                  <RenderIf when={userPNumber.length > 0 && !isCertStep}>
                    <S.ClearBtn
                      type="button"
                      aria-label="입력 지우기"
                      onClick={() => {
                        setValue('PNumber', '')
                        setFocus('PNumber')
                      }}
                    />
                  </RenderIf>
                </>
              }
            />
            {/*인증번호 발송 Button*/}
            <RenderIf when={!isCertStep}>
              <Button.OtpCertRequest
                onClick={handleSubmitOtpCertRequest}
                disabled={!isPNumFilled}
                isLoading={isOtpRequestPending || isMvnoVerifyPending}
                iconSrc={ArrowRight}
                iconAlt=""
                iconSize={24}
                $style={S.OtpRequestButton({
                  ...layoutsConfirm?.submitBtn,
                })}
              />
            </RenderIf>
          </div>
          <div>
            <RenderIf when={isCertStep}>
              <InputElement
                type={'input'}
                isValid={isCertFilled}
                disabled={false}
                $inputStyle={S.ApprovalNumberInputStyle({
                  isFocus: isApprovalNumberFocus,
                  isValid: isCertFilled,
                  ...layoutsInsert?.certs,
                })}
                label={
                  <>
                    <strong>인증번호</strong>를 입력해주세요
                  </>
                }
                children={
                  <>
                    {/*인증번호 Input*/}
                    <input
                      {...register(
                        'ApprovalNumber',
                        registerAttribute.ApprovalNumber.register_options,
                      )}
                      ref={approvalNumberInputRef}
                      type={'tel'}
                      placeholder={'4자리'}
                      onKeyDown={(e) =>
                        handleAutoInputGuard(e, () => {
                          e.key === 'Enter' && handleSubmitOtpVerify()
                        })
                      }
                      autoComplete={'one-time-code'}
                      disabled={false}
                      onFocus={() => {
                        setIsApprovalNumberFocus(true)
                        scrollToAgency()
                      }}
                      onBlur={() => setIsApprovalNumberFocus(false)}
                      onClick={scrollToAgency}
                      maxLength={4}
                    />
                    {/*타이머*/}
                    <S.Timer className={originCount < 60 ? 'danger' : ''}>
                      {count?.substring(3, 12)}
                    </S.Timer>
                    {/*재전송 버튼*/}
                    <Button.RetryOtpCertRequest
                      $style={S.RetryRequestButton({
                        ...layoutsConfirm?.submitBtn,
                      })}
                      onClick={handleSubmitOtpCertRequest}
                      isLoading={isOtpRequestPending || isMvnoVerifyPending}
                      disabled={originCount > 150}
                    />{' '}
                    {originCount <= 150 && !isCertFilled && (
                      <S.ResendTooltip role="status">
                        문자가 안오면
                        <br />
                        <span>재발송</span>을 누르세요!
                      </S.ResendTooltip>
                    )}
                  </>
                }
              />
            </RenderIf>
            <MotionConfig>
              <LayoutGroup id="rop03">
                <S.SwitchComp as={motion.div} initial={false}>
                  {(didFlip ? ['join', 'terms'] : ['terms', 'join']).map((key) => (
                    <motion.div
                      key={key}
                      layout
                      layoutDependency={didFlip}
                      transition={didFlip ? { layout: SPRING } : { layout: { duration: 0 } }}
                    >
                      {key === 'terms' ? (
                        <Terms {...props} />
                      ) : (
                        <S.JoinSubmitContainer $isBtnChange={isOtpReady && !isJoinSubmitting}>
                          <Button.JoinSubmit
                            type="button"
                            className="btn_signup"
                            name={ButtonMsgAfter}
                            $style={S.JoinButton({
                              ...layoutsVerify?.verifyBtn,
                            })}
                            onClick={handleSubmitOtpVerify}
                            isLoading={isJoinSubmitting}
                            icon={
                              isOtpReady ? (
                                <Lottie animationData={ArrowLottie} loop autoplay />
                              ) : undefined
                            }
                            // iconSrc={!isOtpReady ? ArrowRight : undefined}
                            iconAlt=""
                            iconSize={26}
                          />
                        </S.JoinSubmitContainer>
                      )}
                    </motion.div>
                  ))}
                </S.SwitchComp>
              </LayoutGroup>
            </MotionConfig>
          </div>
        </S.CertFormContainer>
        {/* 가입폼 END */}
        {/*유료고지문구*/}
        <S.PaidNoticeConatiner $fontSize={NotiContent.FontSize} $color={NotiContent.FontColor}>
          <p>본 서비스는 통신3사 제휴 부가서비스로 (주)데이터유니버스에서 운영합니다.</p>
          <p>{NotiContent.Text}</p>
        </S.PaidNoticeConatiner>
        {/*푸터*/}
        {!!FooterContent && FooterContent !== '{}' && (
          <S.FooterContainer $bgColor={layoutsFooter.backgroundColor}>
            <div
              dangerouslySetInnerHTML={{
                __html: decodeBase64Html(FooterContent),
              }}
            />
          </S.FooterContainer>
        )}
        <Toast show={isToastShow} message={toastMsg} />
      </S.Rop03FormContainer>
    </S.Rop03FormBackground>
  )
}

export default Rop03JoinFormPageView
